import React, { Component } from 'react';
import { Container, Col, Row } from 'react-bootstrap';

import './section-left-image.scss';

//Images
import TreePruning from '../../../assets/img/services/tree-pruning.jpg';
import TreePlanting from '../../../assets/img/services/tree-planting.jpg';
import TreeRemoval from '../../../assets/img/services/tree-removal.jpg';
import TreeCavity from '../../../assets/img/services/tree-cavity.jpg';
import TreeStump from '../../../assets/img/services/tree-stump.jpg';

class SectionLeftImage extends Component {

    constructor(props) {
        super(props);

        const services = [
            { id: 1, src: TreePruning, title: "Tree pruning shaping and detailing", content: "" },
            { id: 2, src: TreePlanting, title: "Tree planting", content: "" },
            { id: 3, src: TreeRemoval, title: "Tree removal", content: "" },
            { id: 4, src: TreeCavity, title: "Tree cavity removal", content: "" },
            { id: 5, src: TreeStump, title: "Stump grinding", content: "" },
        ];

        this.state = {
            services: services
        }
    }

    render() {

        let title = this.props.title;
        let content = this.props.content;
        let services = this.state.services;

        return (

            <Container fluid={true}>

                <section className='section-left-image'>
                    <h1>
                        {title}
                    </h1>
                    <p>
                        {content}
                    </p>
                    <Container fluid={true}>
                        <Row>
                            {
                                services.map((item) => 
                                        <Col key={item.id} xs={12} md={6} lg={4} className="padding-bottom-20">
                                            <Row>
                                                <Col xs={5} lg={12}>
                                                    <img height='130' src={item.src} alt='images' />
                                                </Col>
                                                <Col xs={7} lg={12} id="text-container">
                                                    <div>
                                                        <h1>{item.title}</h1>
                                                        <p>{item.content}</p>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                )
                            }
                        </Row>
                    </Container>
                        
                </section>
            </Container>

        )
            
    }
}    

export default SectionLeftImage;

  
